import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Modal,
    Button,
    Card,
    CardHeader,
    CardBody,
} from 'reactstrap';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Form, Field } from 'react-final-form';
import axios from "axios";
import {useDispatch, flashSuccess, flashError} from "@/shared/components/flash"

const DeleteMediaTypeModal = ({ organization, isOpen, setOpen, toggle, theme, rtl, program,category, setTrigger,setIsDeleted }) => {
    const dispatch = useDispatch();

    const onSubmitDeleteCategory = () => {
    axios.delete(`/organization/${organization.id}/program/${program.id}/digital-media-type/${category.value}`)
        .then( (res) => {
            if(res.status == 200)  {
                setTrigger( Math.floor(Date.now() / 1000) )
                flashSuccess(dispatch, "Media Category Deleted SuccessFully!!")
                toggle();
                setIsDeleted(true);
            
            }
        })
        .catch( error => {
            console.log(error.response.data);
            flashError(dispatch, error.response.data)
        })
    }

    const validate = values => {
        return true;
    }


    return (
        <Modal className={`modal-action modal-md ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Delete Category
                    <Button className='btn float-end' close onClick={toggle} />
                </CardHeader>
                <CardBody>
                    <Form
                        onSubmit={onSubmitDeleteCategory}
                        validate={validate}
                        initialValues={{
                            category_id: category
                        }}
                    >
                        {({ handleSubmit, form, submitting, pristine, values }) => (
                            <form className="form" onSubmit={handleSubmit}>
                                <div className="form__form-group label-mb-0">
                                    <span className="form__form-group-label">The items under the category "<strong>{ category?.label }</strong>" will be deleted !!! </span>
                                    <span className="form__form-group-label">Are you sure you want to delete the category ?</span>
                                </div>
                                <div className="form__form-group label-mb-0">
                                    <Button className='btn-sm mr-2' color='outline-primary' onClick={toggle}>Cancel</Button>
                                    <Button className='btn-sm btn-danger' color='primary' type='submit'>Delete</Button>
                                </div>
                            </form>
                        )}
                    </Form>
                </CardBody>
            </Card>
        </Modal>
    )
}

DeleteMediaTypeModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};

export default withRouter(connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization
}))(DeleteMediaTypeModal));